import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, ContentChild, Inject, OnInit, TemplateRef, inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ActivatedRoute } from '@angular/router';
import { boxInfo } from '../../../modal/boxInfo';
import { Router, RouterLink, RouterModule, RouterOutlet } from '@angular/router';
import { breadcrumb } from '../../../modal/breadcrumb';
import { IndicadorEspecialService } from '../../../service/IndicadorEspecial.service';
import { SubIndicadorEspecialCardVertical } from '../sub-indicador-especial-vertical/sub-indicador-especial-card-vertical.component';
import { indicador } from '../../../modal/Indicador';
import { indicadorDTO } from '../../../modal/dto/indicadorDTO';
import { valor } from '../../../modal/valor';
import { DisplayComponenteGrafico } from '../display-componente-grafico/display-componente-grafico.component';
import { cabecalhoDTO } from '../../../modal/dto/cabecalhoDTO';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { UtilSharedDataService } from '../../../service/UtilSharedDataService';
import { logosBase64 } from '../../../utilidades/logosBase64';
import { Console } from 'console';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-indicador-especial',
  standalone: true,
  imports: [
    MatSidenavModule,
    MatCardModule,
    MatMenuModule,
    CommonModule,
    RouterLink,
    RouterOutlet,
    RouterModule,
    SubIndicadorEspecialCardVertical,
    DisplayComponenteGrafico
  ],
  templateUrl: './indicador-especial.component.html',
  styleUrl: './indicador-especial.component.scss'
})

export class IndicadorEspecialComponent implements OnInit {
  public NomeTela = "";
  public TipoVisualizacaoTela = "TABELA";
  public DisplayTela = "";
  public IdTela: number = 0;
  public CcPosto = "";
  tempoAtualizacao: any;
  intervalIds: any[] = [];
  public CcOrgao = "";
  public variaveis: string = "";
  textInd: string | null = "";
  textPos: string | null = "";
  textOrg: string | null = "";
  public ListaDentroLista: boolean = false;
  public SemDados: boolean = false;
  public SemOPrimeiroCampo: boolean = false;
  cabecalho: cabecalhoDTO[] = [];
  public listaMesa: indicadorDTO[] = [];
  public listaComponentesGraficos: valor[] = [];
  public atualizando: boolean = false;
  public nomeTipoTela: string = "";
  public PostoNome: string = "";
  data = []
  OrdenacaoCampoPadrao = "";
  OrdenacaoOrientacaoPadrao = "";

  listabreadcrumb: breadcrumb[] = [];
  login: string | null | undefined = null

  currentSortColumnIndex: number | null = null;
  sortDirection: 'asc' | 'desc' = 'asc';

  logosEsquerda: any[] = [];
  logosDireita: any[] = [];

  constructor(private route: ActivatedRoute, private indicadorEspecialService: IndicadorEspecialService,private _logosBase64: logosBase64, private utilSharedDataService: UtilSharedDataService, private router: Router, @Inject(DOCUMENT) private document: Document) {
    try {
      const localStorage = document.defaultView?.localStorage;
      if (localStorage)
        this.login = localStorage.getItem('login');
      if (this.login == null || this.login == undefined)
        this.router.navigate(['/iniciar']);
    }
    catch (ex) {
      this.router.navigate(['/iniciar']);
    }
    const localStorage = document.defaultView?.localStorage;
    if (localStorage) {
      var NewVisu = localStorage.getItem('VISUPADRAO');
      this.TipoVisualizacaoTela = NewVisu == null ? "TABELA" : NewVisu;
    }

    //console.log(NewVisu)

    const breadcrumbString = window.localStorage.getItem('breadcrumb');
    if (breadcrumbString) {
      var bc = JSON.parse(breadcrumbString);
    }
    if (bc != undefined && bc.length != 0) {
      for (let index = 0; index < bc.length; index++) {
        const element = bc[index];
        this.listabreadcrumb.push(new breadcrumb(element.label, element.url));
      }
    }
    else {
      this.listabreadcrumb = [
        new breadcrumb("Dashboard", "/dashboard"),
        new breadcrumb("Posto", "/indicador-posto"),
        new breadcrumb("Orgão", "/indicador-orgao")
      ];
    }
  }

  ngOnInit() {
    this.utilSharedDataService.updateModoApresentacao(false);
    let login = localStorage.getItem('login');
    this.cabecalho = [];

    this._logosBase64.carregarLogos();

        this._logosBase64.logosEsquerda$.subscribe(data => {
            this.logosEsquerda = data;
        });

        this._logosBase64.logosDireita$.subscribe(data => {
            this.logosDireita = data;
        });

    // Roteamento de telas
    this.route.queryParamMap.subscribe(params => {
      let tipotela = params.get('tipoTela');
      this.IdTela = tipotela == null ? 0 : Number.parseInt(tipotela);
      this.textInd = params.get('textInd');
      this.textPos = params.get('textPos');
      this.textOrg = params.get('textOrg');
      let CodPosto = params.get('CcPosto');
      this.CcPosto = CodPosto == null ? "" : CodPosto;
      var retrievedObject = localStorage.getItem('salaSituacao');
      if (retrievedObject != null) {
        var sala = JSON.parse(retrievedObject);
        //console.log(retrievedObject);
        //console.table(sala['postos']);
        var postosUsuario = sala['postos'];
        if (!sala.postos.includes(Number.parseInt(this.CcPosto)))
          this.router.navigate(['/dashboard']);
      }
      else
        this.router.navigate(['/iniciar']);
      let CodOrgao = params.get('CcOrgao');
      let varr = params.get('variaveis');
      this.variaveis = varr == null ? "" : varr;
      this.CcOrgao = CodOrgao == null ? "" : CodOrgao;
      this.indicadorEspecialService.getindicadores(this.IdTela, this.CcPosto, this.CcOrgao, this.variaveis, login == undefined ? "" : login).pipe(
      ).subscribe((response) => {

        console.log(response)
        this.data = response['indicadores'];

        if (this.data.length == 0) {
          this.SemDados = true;
        }
        else {
          this.tempoAtualizacao = response["tempoAtualizacao"];
          this.DisplayTela = response['visualizacaoDisplay'];
          if (response["orgao"] == null) {
            this.NomeTela =
              this.data[0]["nome"] + (this.textInd == null ? "" : this.textInd)
              + " (do posto "
              + response["posto"]['posto']['descricao']
              + (this.textPos == null ? "" : this.textPos) + ")";
          }
          else {
            this.NomeTela =
              this.data[0]["nome"] + (this.textInd == null ? "" : this.textInd)
              + " (do orgão " + response["orgao"]['orgao']['descricao']
              + (this.textOrg == null ? "" : this.textOrg) + " do posto "
              + response["posto"]['posto']['descricao']
              + (this.textPos == null ? "" : this.textPos) + ")";
          }

          this.PostoNome = response["posto"]['posto']['descricao'];
          if (this.data[0]["nome"] == response["nomeTipoTela"])
            this.nomeTipoTela = response["nomeTipoTela"];
          else
            this.nomeTipoTela = this.data[0]["nome"] + " - " + response["nomeTipoTela"];

          if (response["camposGrafico"] != null || response["camposGrafico"] != undefined) {
            this.OrdenacaoCampoPadrao = response["camposGrafico"][0]["nome"];
          }
          this.OrdenacaoOrientacaoPadrao = response["ordenacaoOrientacao"];
          this.listabreadcrumb.push(new breadcrumb("" + response["nomeTipoTela"], ""));
          this.data.forEach(element => {
            var v = element['valor'];
            var ind: indicadorDTO = new indicadorDTO(undefined, "", "", 0, "", "", "", null, new valor(undefined, "", "", "", 0, 0, "", 0, null, null, null, null, null, null, null, null, null, null, null, 0, null, [], null), [], undefined, "");
            var val = new valor(
              v['codigo'],
              v['nome'],
              v['expressao'],
              v['icone'],
              v['denominador'],
              v['nominador'],
              v['valorFormatado'],
              v['valorSemFormato'],
              v['naoMostraCampo'],
              v['naoMostraTitulo'],
              v['orientacaoLoop'],
              v['ehLooping'],
              v['ehComponenteGrafico'],
              v['componenteGraficoHtml'],
              v['componenteGraficoCss'],
              v['componenteGraficoPossicao'],
              v['ehLink'],
              v['linkRedirect'],
              v['linkVariaveis'],
              v['ordem'],
              v['ehCampoCabecalho'],
              this.getValores(v['valores'], ind),
              v['cor']
            )
            if (val.naoMostraCampo)
              this.SemOPrimeiroCampo = true;
            ind = new indicadorDTO(
              element['codigo'],
              element['nome'],
              element['cor'],
              element['etapa'],
              element['icone'],
              element['corFarol'],
              element['ordenacaoOrientacao'],
              element['proximaEtapa'],
              val, [], undefined, ""
            );
            ind.valores = this.getValores(element['valores'], ind)
            if (ind.valor.naoMostraCampo) {
              var Vcabecalho = this.getValoresCabecalho(ind.valores)
              if (Vcabecalho != null)
                ind.valor = Vcabecalho;
            }


            this.listaMesa.push(ind);

          });

          this.cabecalho = this.montarCabecalho(this.listaMesa);


          this.listaMesa.sort((a, b) => {
            const lengthA = a.valores ? a.valores.length : 0;
            const lengthB = b.valores ? b.valores.length : 0;
            return lengthB - lengthA;
          });

          this.setAtualizacaoindicadores();
          console.log(this.listaMesa)

          this.ordenarLista(this.OrdenacaoCampoPadrao, this.OrdenacaoOrientacaoPadrao != "DESC");

        }
      });
    });
  }



  ordenarLista(nomeColuna: string, crescente: boolean) {
    this.listaMesa = this.listaMesa.sort((a, b) => {
      const valorA = a.valores?.find(v => v.nome === nomeColuna)?.valorSemFormato;
      const valorB = b.valores?.find(v => v.nome === nomeColuna)?.valorSemFormato;

      const valorC = a.valor.nome === nomeColuna ? a.valor.valorSemFormato : null;
      const valorD = b.valor.nome === nomeColuna ? a.valor.valorSemFormato : null;
      // Se algum dos valores for undefined ou null, trata como igual (não muda a ordem)
      if ((valorA == null || valorB == null) && (valorD == null || valorC == null)) return 0;
      if ((valorA != null && valorB != null)) {
        if (valorA < valorB) return crescente ? -1 : 1;
        if (valorA > valorB) return crescente ? 1 : -1;
      }
      else if ((valorC != null && valorD != null)) {
        if (valorC < valorD) return crescente ? -1 : 1;
        if (valorC > valorD) return crescente ? 1 : -1;
      }
      return 0;
    });

  }


  ngOnDestroy() {
    this.intervalIds.forEach(intervalId => clearInterval(intervalId));
  }

  setAtualizacaoindicadores() {
    let login = localStorage.getItem('login');
    const intervalId = setInterval(() => {
      this.atualizando = true;

      this.indicadorEspecialService.getindicadores(this.IdTela, this.CcPosto, this.CcOrgao, this.variaveis, login == undefined ? "" : login).pipe(
      ).subscribe((response) => {
        this.listaMesa = [];

        //console.log(response)
        this.data = response['indicadores'];
        if (this.data.length == 0) {
          this.SemDados = true;
        }
        else {
          this.data.forEach(element => {
            var v = element['valor'];
            var ind: indicadorDTO = new indicadorDTO(undefined, "", "", 0, "", "", "", null, new valor(undefined, "", "", "", 0, 0, "", 0, null, null, null, null, null, null, null, null, null, null, null, 0, null, [], null), [], undefined, "");
            var val = new valor(
              v['codigo'],
              v['nome'],
              v['expressao'],
              v['icone'],
              v['denominador'],
              v['nominador'],
              v['valorFormatado'],
              v['valorSemFormato'],
              v['naoMostraCampo'],
              v['naoMostraTitulo'],
              v['orientacaoLoop'],
              v['ehLooping'],
              v['ehComponenteGrafico'],
              v['componenteGraficoHtml'],
              v['componenteGraficoCss'],
              v['componenteGraficoPossicao'],
              v['ehLink'],
              v['linkRedirect'],
              v['linkVariaveis'],
              v['ordem'],
              v['ehCampoCabecalho'],
              this.getValores(v['valores'], ind),
              v['cor']
            )
            if (val.naoMostraCampo)
              this.SemOPrimeiroCampo = true;
            ind = new indicadorDTO(
              element['codigo'],
              element['nome'],
              element['cor'],
              element['etapa'],
              element['icone'],
              element['corFarol'],
              element['ordenacaoOrientacao'],
              element['proximaEtapa'],
              val, [], undefined, ""
            );
            ind.valores = this.getValores(element['valores'], ind)
            if (ind.valor.naoMostraCampo) {
              var Vcabecalho = this.getValoresCabecalho(ind.valores)
              if (Vcabecalho != null)
                ind.valor = Vcabecalho;
            }

            this.listaMesa.push(ind);


          });

          this.cabecalho = this.montarCabecalho(this.listaMesa);


          this.listaMesa.sort((a, b) => {
            const lengthA = a.valores ? a.valores.length : 0;
            const lengthB = b.valores ? b.valores.length : 0;
            return lengthB - lengthA;
          });
          this.ordenarLista(this.OrdenacaoCampoPadrao, this.OrdenacaoOrientacaoPadrao != "DESC");
          this.aplicarOrdenacao();

          this.atualizando = false;

        }
      });
    }, (this.tempoAtualizacao * 1000));
    this.intervalIds.push(intervalId);
  }

  navigateWithState(Link: string | null, variaveis: string | null) {
    this.listabreadcrumb[this.listabreadcrumb.length - 1].url = this.router.url.split('?')[0];
    window.localStorage.setItem('breadcrumb', JSON.stringify(this.listabreadcrumb));
    this.router.navigate(['' + Link], {
      queryParams: { tipoTela: this.IdTela, variaveis, CcPosto: this.CcPosto, CcOrgao: this.CcOrgao }
    });
  }

  navigateWithStateBC(Link: string | null) {
    if (Link != null) {
      const index = this.listabreadcrumb.findIndex(b => b.url === Link);

      if (index !== -1) {
        this.listabreadcrumb = this.listabreadcrumb.slice(0, index);
      }
      window.localStorage.setItem('breadcrumb', JSON.stringify(this.listabreadcrumb));
    }
    this.router.navigate(['' + Link], {
      queryParams: { tipoTela: this.IdTela, CcPosto: this.CcPosto, CcOrgao: this.CcOrgao, textInd: this.textInd, textPos: this.textPos }
    });
  }


  getValoresCabecalho(valores: valor[]): valor | null {
    var retorno: valor | null = null;
    valores.forEach(element => {
      if (element.ehCampoCabecalho)
        retorno = element;
      else {
        var v = this.getValoresCabecalho(element.valores)
        if (v != null)
          retorno = v
      }
    });
    return retorno;
  }


  montarCabecalho(listaMesa: any[]): any[] {
    const cabecalho: any[] = [];

    if (!listaMesa || listaMesa.length === 0) return cabecalho;

    const indicador = listaMesa[0];
    const valor = indicador.valor || {};

    const isCabecalhoNormal = valor.ehCampoCabecalho === true;

    // Primeira coluna: "Ponto"
    cabecalho.push({
      nome: isCabecalhoNormal ? valor.nome : '',
      icone: 'icofont-users-alt-4',
      isPrimeiraColuna: true
    });

    // Verifica se há estrutura com subvalores (estrutura especial)
    const hasEstruturaEspecial = !isCabecalhoNormal &&
      Array.isArray(indicador.valores) &&
      indicador.valores.some((val: any) =>
        Array.isArray(val.valores) && val.valores.length > 0
      );

    if (hasEstruturaEspecial) {
      // Segunda coluna: "Serviço de mesa"
      if(this.IdTela!=22){
      cabecalho.push({
        nome: 'Serviço de mesa',
        icone: '',
        isPrimeiraColuna: false
      });
    }
      // Pega o primeiro item que tem subvalores para extrair os cabeçalhos
      const itemComSubvalores = indicador.valores.find((val: any) =>
        Array.isArray(val.valores) && val.valores.length > 0
      );

      itemComSubvalores?.valores.forEach((val: any) => {
        cabecalho.push({
          nome: val.nome,
          icone: val.icone || '',
          isPrimeiraColuna: false
        });
      });

    } else {
      // Estrutura padrão (sem subvalores)
      indicador.valores?.forEach((val: any) => {
        if (!val.ehCampoCabecalho) {
          cabecalho.push({
            nome: val.nome,
            icone: val.icone || '',
            isPrimeiraColuna: false
          });
        }
      });
    }

    //console.log("Cabeçalho gerado:", cabecalho);
    return cabecalho;
  }


  getValores(response: [], ind: indicadorDTO): valor[] {
    if (response == undefined) {
      return [];
    }
    var listavalores: valor[] = [];
    response.forEach(element => {
      var val = new valor(
        element['codigo'],
        element['nome'],
        element['expressao'],
        element['icone'],
        element['denominador'],
        element['nominador'],
        element['valorFormatado'],
        element['valorSemFormato'],
        element['naoMostraCampo'],
        element['naoMostraTitulo'],
        element['orientacaoLoop'],
        element['ehLooping'],
        element['ehComponenteGrafico'],
        element['componenteGraficoHtml'],
        element['componenteGraficoCss'],
        element['componenteGraficoPossicao'],
        element['ehLink'],
        element['linkRedirect'],
        element['linkVariaveis'],
        element['ordem'],
        element['ehCampoCabecalho'],
        this.getValores(element['valores'], ind),
        element['cor']
      )
      if (val.naoMostraCampo != true) {
        if (!this.cabecalho.find(x => x.nome == val.nome)) {
          var c: cabecalhoDTO = new cabecalhoDTO(val.nome, val.ordem, val.icone);

          this.cabecalho.push(c);
        }
      }
      this.cabecalho.sort((a, b) => {
        return a.ordem - b.ordem
      });
      if (val.ehComponenteGrafico) {
        if (ind.listaComponentesGraficos == undefined)
          ind.listaComponentesGraficos = [];
        if (ind.listaComponentesGraficos.find(x =>
          x.valorFormatado == val.valorFormatado &&
          val.componenteGraficoCss == x.componenteGraficoCss &&
          val.componenteGraficoHtml == x.componenteGraficoHtml &&
          x.componenteGraficoPossicao == val.componenteGraficoPossicao) == null) // checa se ja não colocou o mesmo componente grafico na lista
          ind.listaComponentesGraficos.push(val);
      }
      listavalores.push(val);
      if (val != undefined && val.ehLooping == true) {
        this.ListaDentroLista = true;
      }
    });
    return listavalores;
  }

  MudarVisualizacaoTela(NovoEstilo: string) {
    this.TipoVisualizacaoTela = NovoEstilo;
    const localStorage = document.defaultView?.localStorage;
    if (localStorage) {
      localStorage.setItem('VISUPADRAO', NovoEstilo);
    }
  }

  exportTableToExcel(): void {
    // Referência à tabela
    const dados: any[] = this.getDados("EXCEL");

    // Função para formatar a data no formato DD/MM/YYYY
    const formatarDataBR = (data: Date) => {
      const dia = String(data.getDate()).padStart(2, '0');
      const mes = String(data.getMonth() + 1).padStart(2, '0');
      const ano = data.getFullYear();
      return `${dia}/${mes}/${ano}`;
    };

    const hoje = new Date();
    const nomeUsuario = this.login || 'Usuário não identificado'; // Obtém o nome do usuário
    const dataGeracao = formatarDataBR(hoje); // Formata a data no padrão BR

    // Adiciona uma linha vazia
    dados.push([]);

    // Adiciona uma linha com o nome do usuário e a data em uma célula mesclada
    dados.push([{
      v: `Emitente: ${nomeUsuario} | DATA: ${dataGeracao}`,
      s: {
        alignment: { horizontal: 'center' },
        border: {
          top: { style: 'thin' },
          bottom: { style: 'thin' },
        }
      }
    }]);

    // Adiciona uma linha vazia
    dados.push([]);

    dados.push([{
      v: `FONTE: ${this.nomeTipoTela} `,
      s: {
        alignment: { horizontal: 'center' },
        border: {
          top: { style: 'thin' },
          bottom: { style: 'thin' },
        }
      }
    }]);


    // Converte os dados para uma planilha
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(dados);
    // Cria um WorkBook
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, ws, 'Sheet1');

    // Converte para um arquivo binário
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // Salva o arquivo
    const data: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
    saveAs(data, this.nomeTipoTela.replaceAll(" ", "_") + "-" + this.PostoNome.replaceAll(" ", "_") + "-" + formattedDate + '.xlsx');
  }




  extrairTabelaParaPDF() {
    let dados: any[][] = this.getDados("PDF");

    if (!dados || dados.length === 0) {
      console.error("Erro: Nenhum dado disponível para exportação.");
      return;
    }

    const today = new Date();
    const formattedDate = `${today.getDate().toString().padStart(2, '0')}/${(today.getMonth() + 1).toString().padStart(2, '0')}/${today.getFullYear()}`;
    const formattedTime = `${today.getHours().toString().padStart(2, '0')}:${today.getMinutes().toString().padStart(2, '0')}`;
    const formattedDateTime = `${formattedDate} - ${formattedTime}`;

    // Reduz o tamanho da fonte e ajusta a largura das colunas
    const dadosFormatados = dados.map((linha) =>
      linha.map((coluna) => ({
        text: coluna,
        fontSize: 12,
        margin: [2, 2, 2, 2]
      }))
    );

    // Definição do PDF
    const docDefinition: any = {
      pageSize: 'A4',
      pageOrientation: 'landscape',
      pageMargins: [20, 40, 20, 20],

      content: [
        {
          columns: [
            ...this.logosEsquerda,
            {
              width: "*", // Ocupa o espaço do meio
              text: "" // Espaço vazio entre os logos
            },
            {
              width: "auto", // Ajusta ao conteúdo dos logos
              alignment: "right",
              columnGap: 35, // Espaço fixo entre os logos
              columns:  this.logosDireita
            }
          ]
        },
        {
          text: `Relatório: ${this.nomeTipoTela}`,
          style: 'header'
        },
        {

          columns: [
            {
              //width: "*", // Usa o espaço disponível
              text: this.PostoNome + " - " + formattedDateTime,
              style: 'posto',
              margin: [0, 30, 0, -10] // Adiciona um espaçamento superior
            },
            {

              columns: [

                {
                  width: "auto", // Garante que o login não fique comprimido
                  text: `Emitido por: ${this.login}`,
                  style: 'posto',
                  fontSize: 8,
                  margin: [0, 30, 0, -10],// Adiciona um espaçamento superior
                  noWrap: true // Impede a quebra do texto
                },
              ]
            }

          ],

        },
        {
          table: {
            headerRows: 1,
            widths: Array(dados[0].length).fill('auto'),
            body: dadosFormatados
          },
          margin: [0, 10, 0, 10]
        },
        {
          text: [
            { text: "Rua Agueda Gonçalves, 240 - Taboão da Serra - SP, 06760-900 - Tel:(11)28456000 (PABX)\n", fontSize: 8, alignment: 'center' },
            { text: "Correspondência: Caixa Postal 25901 - CEP: 05513-970 - SÃO PAULO-SP\n", fontSize: 8, alignment: 'center' },
            { text: "www.prodesp.sp.gov.br - prodesp@prodesp.sp.gov.br", fontSize: 8, alignment: 'center' }
          ],
          margin: [0, 10, 0, 0] // Remove espaçamento entre as linhas
        }

      ],
      styles: {
        header: {
          fontSize: 12,
          bold: true,
          alignment: 'center'
        },
        posto: {
          fontSize: 10,
          bold: false,
          alignment: 'left',

        },
      },
      footer: (currentPage: number, pageCount: number) => {
        return {
          text: `Página ${currentPage} de ${pageCount}`,
          alignment: 'center',
          fontSize: 8,
          pageMargins: [20, 40, 20, 40] // Espaçamento do rodapé
        };
      }
    };

    const formattedDate2 = today.toISOString().split('T')[0];
    pdfMake.createPdf(docDefinition).download(this.nomeTipoTela.replaceAll(" ", "_") + "-" + this.PostoNome.replaceAll(" ", "_") + "-" + formattedDate2 + '.pdf');
  }



  getDados(tipo: string) {
    const dados: any[] = [];

    const tabelas = document.querySelectorAll('#tableDados tbody tr'); // Seleciona todas as linhas da tabela principal

    tabelas.forEach((linha: Element, index: number) => {  // Ajuste aqui para corresponder à assinatura correta
      const celulas = Array.from(linha.querySelectorAll('td')); // Pega todas as células da linha

      const linhaDados: any[] = [];

      // Itera sobre cada célula
      celulas.forEach((celula: HTMLTableCellElement) => {
        const tabelasInternas = Array.from(celula.querySelectorAll('table')); // Procura por tabelas dentro da célula

        if (tabelasInternas.length > 0) {
          // Se houver tabelas internas, nao pega o conteúdo delas tava duplicando os dados
        } else {
          // Caso contrário, pega o texto da célula normal
          if (dados.length == 0 && celula.innerText.trim() == "") {
            linhaDados.push(celula.innerText.trim());
          }
          if (celula.innerText.trim() != "") {
            if (tipo == "PDF") {
              var fontSize = 10;
              if (this.cabecalho.length < 5)
                fontSize = 15;
              else if (this.cabecalho.length < 11)
                fontSize = 10;
              else if (this.cabecalho.length > 11)
                fontSize = 8;

              linhaDados.push({
                text: celula.innerText.trim(),
                fontSize: fontSize // Ajuste o tamanho conforme necessário
              });
            }
            else
              linhaDados.push(celula.innerText.trim());
          }
        }
      });

      if (linhaDados.length > 1) {
        //console.log(linhaDados);
        dados.push(linhaDados); // Adiciona a linha de dados à lista de resultados
      }
    });
    return dados;
  }

  extrairConteudoTabelaInterna(tabela: HTMLTableElement): any[] {
    const conteudo: any[] = [];
    const linhasInternas = tabela.querySelectorAll('tr');

    linhasInternas.forEach((linhaInterna: HTMLTableRowElement) => {
      const celulasInternas = Array.from(linhaInterna.querySelectorAll('td'));
      const celulasInternasSemVazio = celulasInternas.filter(x => x.innerText.trim() != "");
      const linhaDadosInterna: any[] = celulasInternasSemVazio.map((celulaInterna: HTMLTableCellElement) => celulaInterna.innerText.trim());
      conteudo.push(linhaDadosInterna);
    });

    return conteudo;
  }




  aplicarOrdenacao(): void {
    const index = this.currentSortColumnIndex;
    if (typeof index !== 'number') return;

    const isModeloAninhado = Array.isArray(this.listaMesa) &&
      this.listaMesa.length === 1 &&
      Array.isArray(this.listaMesa[0]?.valores);

    const usaCabecalho = this.listaMesa[0]?.valor?.ehCampoCabecalho ?? false;
    const realIndex = index === 0 ? 0 : isModeloAninhado ? index : usaCabecalho ? index : index - 1;

    // Ordena a lista principal 
    if (isModeloAninhado && index === 0) {
      this.listaMesa.sort((a, b) => {
        let valorA = a.valor?.valorFormatado || '';
        let valorB = b.valor?.valorFormatado || '';

        if (typeof valorA === 'string') valorA = valorA.toLowerCase();
        if (typeof valorB === 'string') valorB = valorB.toLowerCase();

        return this.sortDirection === 'asc'
          ? valorA > valorB ? 1 : valorA < valorB ? -1 : 0
          : valorA < valorB ? 1 : valorA > valorB ? -1 : 0;
      });
      return;
    }

    // Ordena os "Serviços da mesa" ou "Avaliação do atendente" dentro do ponto
    if (isModeloAninhado && (index === 1 || index === 2)) {
      const listaServicos = this.listaMesa[0]?.valores ?? [];

      listaServicos.sort((a, b) => {
        const extrairValor = (item: any): any => {
          if (index === 1) return item.valorFormatado || ''; // Nome do serviço
          if (index === 2) return item.valores?.[0]?.valorFormatado || ''; // Avaliação
          return '';
        };

        let valorA = extrairValor(a);
        let valorB = extrairValor(b);

        const isPercentual = (val: string) =>
          /\d+,\d+%/.test(val) || /\d+%/.test(val);

        const parsePercentual = (val: string): number => {
          return parseFloat(val.replace('%', '').replace(',', '.')) || 0;
        };

        if (index === 2) {
          valorA = parsePercentual(valorA);
          valorB = parsePercentual(valorB);
        } else {
          if (typeof valorA === 'string') valorA = valorA.toLowerCase();
          if (typeof valorB === 'string') valorB = valorB.toLowerCase();
        }

        return this.sortDirection === 'asc'
          ? valorA > valorB ? 1 : valorA < valorB ? -1 : 0
          : valorA < valorB ? 1 : valorA > valorB ? -1 : 0;
      });

      return;
    }

    // Ordenação padrão para estruturas comuns (inclusive colunas 1 e 2 fora do modelo aninhado)
    const listaAlvo = isModeloAninhado ? this.listaMesa[0]?.valores ?? [] : this.listaMesa;
    if (!Array.isArray(listaAlvo)) return;

    listaAlvo.sort((a, b) => {
      const extrairValor = (item: any): any => {
        if (index === 0) {
          return item.valor?.valorFormatado || item.valorFormatado || '';
        }
        const direto = item.valores?.[realIndex]?.valorFormatado;
        const aninhado = item.valores?.[realIndex]?.valores?.[0]?.valorFormatado;
        return aninhado ?? direto ?? '';
      };

      let valorA = extrairValor(a);
      let valorB = extrairValor(b);

      const isTempoFormatado = (val: string) =>
        /\d+h\s?\d*min?/.test(val) || /\d+min/.test(val);

      const parseTempo = (val: string): number => {
        const match = val?.match(/(?:(\d+)h)?\s*(?:(\d+)min)?/);
        const horas = parseInt(match?.[1] || '0', 10);
        const minutos = parseInt(match?.[2] || '0', 10);
        return horas * 60 + minutos;
      };

      if (typeof valorA === 'string' && isTempoFormatado(valorA)) valorA = parseTempo(valorA);
      if (typeof valorB === 'string' && isTempoFormatado(valorB)) valorB = parseTempo(valorB);

      const isPercentual = (val: string) =>
        /\d+,\d+%/.test(val) || /\d+%/.test(val);

      const parsePercentual = (val: string): number => {
        return parseFloat(val.replace('%', '').replace(',', '.')) || 0;
      };

      if (typeof valorA === 'string' && isPercentual(valorA)) valorA = parsePercentual(valorA);
      if (typeof valorB === 'string' && isPercentual(valorB)) valorB = parsePercentual(valorB);

      //  converte número puro que vem como string
      const isNumeroPuro = (val: string) => /^\d+([.,]\d+)?$/.test(val);

      if (typeof valorA === 'string' && isNumeroPuro(valorA)) {
        valorA = parseFloat(valorA.replace(',', '.'));
      } else if (typeof valorA === 'string') {
        valorA = valorA.toLowerCase();
      }

      if (typeof valorB === 'string' && isNumeroPuro(valorB)) {
        valorB = parseFloat(valorB.replace(',', '.'));
      } else if (typeof valorB === 'string') {
        valorB = valorB.toLowerCase();
      }

      return this.sortDirection === 'asc'
        ? valorA > valorB ? 1 : valorA < valorB ? -1 : 0
        : valorA < valorB ? 1 : valorA > valorB ? -1 : 0;
    });
  }



  ordenarPorColuna(index: number): void {


    if (this.currentSortColumnIndex === index) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.currentSortColumnIndex = index;
      this.sortDirection = 'asc';
    }

    this.aplicarOrdenacao();
  }



}